import React from 'react';

import { PartnersBanner, PartnersTop, PartnersCards, PartnersOthers, PartnersSalons } from '../components';

class Partners extends React.Component {
    render() {
        const {cards, /*others*/} = this.props.texts.langs.partners;
        return (
            <div className="bc-beige2">
                <PartnersBanner/>
                <PartnersTop/>
                <PartnersCards partners={cards}/>
                {/*<PartnersOthers partners={others}/>*/}
                <PartnersSalons/>
            </div>
        );
    }
}

export default Partners;


// WEBPACK FOOTER //
// ./src/containers/Partners.js